import React, { Component } from 'react'

export default class BookMarkList extends Component {
  constructor () {
    super()
    this.state = {
      bookmark: ''
    }
  }

  onClickBookmarkField (e) {
    e.preventDefault()
    let newState = this.state.bookmark

    if (newState === 'open') {
      newState = ''
    } else {
      newState = 'open'
    }
    this.setState({
      bookmark: newState
    })
  }

  render() {
    const classBookmark = `menu-bookmark relative ${this.state.bookmark}`
    return (
      <div className={classBookmark}>
        <a href="" className="pushMenu" onClick={this.onClickBookmarkField.bind(this)}>
          <span><i className="fa fa-bookmark"></i></span>
          <span><i className="fa fa-ellipsis-v"></i></span>
        </a>
        <span className="clear"></span>
        <ul className="clear">
          <li>
            <a href="">
              <i className="fa fa-share"></i> Compartilhar
            </a>
          </li>
        </ul>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/atoms/bookmark-list.js